import { render, staticRenderFns } from "./NewQueueDayHeader.vue?vue&type=template&id=dae98432&scoped=true&"
import script from "./NewQueueDayHeader.vue?vue&type=script&lang=js&"
export * from "./NewQueueDayHeader.vue?vue&type=script&lang=js&"
import style0 from "./NewQueueDayHeader.vue?vue&type=style&index=0&id=dae98432&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae98432",
  null
  
)

export default component.exports